// The Ortic Drive sync API (docs/drive-api.md) as the Documents page uses it
import axios from 'axios'

const base = '/api/drive'

export const driveApi = {
    spaces: () => axios.get(`${base}/spaces`).then(r => r.data.spaces),
    // Project spaces (issue #172): what a new one can belong to, and making, changing and deleting one
    spaceOptions: () => axios.get(`${base}/spaces/options`).then(r => r.data),
    createSpace: space => axios.post(`${base}/spaces`, space).then(r => r.data.space),
    updateSpace: (id, changes) => axios.patch(`${base}/spaces/${id}`, changes).then(r => r.data.space),
    deleteSpace: id => axios.delete(`${base}/spaces/${id}`),
    children: (folderId, params = {}) => axios.get(`${base}/nodes/${folderId}/children`, { params }).then(r => r.data),
    mkdir: (parentId, name) => axios.post(`${base}/nodes`, { parent_id: parentId, name }).then(r => r.data.node),
    update: (id, changes, rev) => axios.patch(`${base}/nodes/${id}`, changes, rev ? { headers: { 'If-Match': String(rev) } } : {}).then(r => r.data.node),
    trash: id => axios.delete(`${base}/nodes/${id}`).then(r => r.data.node),
    restore: id => axios.post(`${base}/nodes/${id}/restore`).then(r => r.data.node),
    purge: id => axios.delete(`${base}/trash/${id}`),
    trashList: spaceId => axios.get(`${base}/spaces/${spaceId}/trash`).then(r => r.data),
    versions: id => axios.get(`${base}/nodes/${id}/versions`).then(r => r.data.versions),
    restoreVersion: (id, versionId) => axios.post(`${base}/nodes/${id}/versions/${versionId}/restore`).then(r => r.data.node),
    batch: operations => axios.post(`${base}/batch`, { operations }).then(r => r.data.results),
    members: spaceId => axios.get(`${base}/spaces/${spaceId}/members`).then(r => r.data),
    setMember: (spaceId, member) => axios.put(`${base}/spaces/${spaceId}/members`, member).then(r => r.data),
    memberSuggestions: spaceId => axios.get(`${base}/spaces/${spaceId}/members/suggestions`).then(r => r.data),
    removeMember: (spaceId, memberId) => axios.delete(`${base}/spaces/${spaceId}/members/${memberId}`),
    people: q => axios.get(`${base}/people`, { params: { q } }).then(r => r.data),
    devices: () => axios.get(`${base}/devices`).then(r => r.data.devices),
    revokeDevice: id => axios.delete(`${base}/devices/${id}`),
    // The desktop app's current release; 404 until one is published
    clientRelease: () => axios.get(`${base}/client/latest`).then(r => r.data),
    // Guest links of a folder: shared with an address outside the app
    links: folderId => axios.get(`${base}/nodes/${folderId}/links`).then(r => r.data.links),
    shareWithGuest: (folderId, link) => axios.post(`${base}/nodes/${folderId}/links`, link).then(r => r.data.link),
    updateLink: (id, changes) => axios.patch(`${base}/links/${id}`, changes).then(r => r.data.link),
    resendLink: id => axios.post(`${base}/links/${id}/send`).then(r => r.data.link),
    revokeLink: id => axios.delete(`${base}/links/${id}`).then(r => r.data.link),
    linkEvents: id => axios.get(`${base}/links/${id}/events`).then(r => r.data.events),

    // Links the browser follows itself (downloads, previews): signed in through the token cookie
    contentUrl: (id, { inline = false, version = null } = {}) => {
        const params = new URLSearchParams()
        if (inline) params.set('inline', '1')
        if (version) params.set('version', version)
        const query = params.toString()
        return `${base}/nodes/${id}/content${query ? '?' + query : ''}`
    },
    zipUrl: ids => `${base}/zip?ids=${ids.join(',')}`,
}

// The API's error message, for a toast
export function apiError(error, fallback) {
    const body = error?.response?.data
    return body?.message || body?.error?.message || fallback
}
